jQuery(function ($) {
  if ($("#growth-of-10k").length > 0) {
    var appConfig = {
      components: {
        marketsSvgchart: {
          type: "markets-components-svgchart",
          version: "~2.43.0",
          settings: {
            mainTicker: growth_of_10k.settings.mainTicker,
              showProspectusBenchmark: true,
            mainTickerColor: "#2D343A",
            compareTickers: growth_of_10k.settings.benchmarks,
            compareColors: ["#304147", "#f06c00", "#12749a"],
            charts: {
              mainChart: {
                dataType: "growth10K",
                showGridLines: false,
              },
            },
            showCategory: "true",
            intervalType: "TenYear",
            legendInfoLabel: "Name",
            frequency: "d",
            hideMenu: "true",
            labels: {
              en: {
                oneYear: "1YR",
                threeYear: "3YR",
                fiveYear: "5YR",
                tenYear: "10YR",
              },
            },
          },
        },
      },
    };
    morningstar.loader.load(
      {
        instid: "JNSSB",
        appConfig: appConfig,
        apiTokens: {
          apiGatewayToken: growth_of_10k.settings.access_token,
        },
        environment: "prod",
      },
      function (appConfig) {
        var svgchart = morningstar.initComponent("marketsSvgchart", {
          container: document.getElementById("growth-of-10k"),
        });
      }
    );
  }
});

/**
 * Analytics tracking for 10k growth chart
 */
(function (window, document, $, undefined) {
  "use strict";

  // on click event on 10k growth chart menu  //.mkts-cmpt-svgcht-menubar
  $("#growth-of-10k").click(function () {
    var chartName = $("#growth_of_10k_card #fund-chart-name").text();
    gtmHelper.fundChartInteraction(chartName);
  });
})(window, document, jQuery);
